const countyCountry = row => (row.country && row.country.name) || "—";

export default {
  slug: "counties",
  endpoint: "counties/",
  titleKey: "counties_title",
  columns: [
    { field: "name", label: "f_name" },
    { label: "f_country", format: countyCountry },
  ],
  filters: [{ name: "country", entity: "countries" }],
  fields: [
    { name: "name", type: "text", label: "f_name", required: true },
    { name: "country", type: "entity", entity: "countries", label: "f_country", required: true, query: { active: true } },
  ],
  softDelete: true,
};
